var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "esc2kh5rma",
  cx: 19.911,
  cy: 19.911,
  r: 19.911
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-32 -127) translate(15 127) translate(17)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "p7wjnbblvb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#esc2kh5rma"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#C9C4F8",
  xlinkHref: "#esc2kh5rma"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#p7wjnbblvb)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.154 15.683c-.795-.279-1.296-.92-2.239-.84-1.677.143-2.867 1.966-4.482.73C2.48 14.074 2.993 5.066 3.84 3.025c.718-1.73 2.043-.039 3.932-.62 2.196-.675 4.09 1 5.225 2.739 1.181 1.81 1.79 4.116 1.615 6.24-.16 1.963-.528 5.327-3.458 4.298",
  transform: "matrix(-1 0 0 1 32.978 10.145) translate(2.756 .222)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8BE9C",
  d: "M7.53 16.889L11.086 16.889 11.086 11.556 7.53 11.556z",
  transform: "matrix(-1 0 0 1 32.978 10.145) translate(2.756 .222)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.086 13.715v-2.16H7.53v3.112c1.173-.037 2.565-.252 3.556-.952",
  transform: "matrix(-1 0 0 1 32.978 10.145) translate(2.756 .222)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8BD9C",
  d: "M.42 19.111c1.09-1.636 2.805-2.08 2.805-2.08l4.11-1.475h3.92l5.025 1.475s1.715.444 2.806 2.08H.419M11.48 11.777c-.125.289-.3.557-.544.791-.609.584-1.323 1.058-2.105 1.377-.96.392-2.409.443-3.172-.344-.618-.639-.957-1.605-1.226-2.434-.522-1.61-.515-3.371-.382-5.044.03-.382.069-.764.133-1.142.597-3.65 3.734-3.641 3.734-3.641 2.368-.103 4.53 1.011 4.894 3.496.14.952-.044 1.974-.092 2.925-.035.7-.122 1.398-.346 2.064-.23.681-.608 1.295-.893 1.952",
  transform: "matrix(-1 0 0 1 32.978 10.145) translate(2.756 .222)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.837 1.54c3.042-2.785 8.662-1.725 10.379 2.63.53 1.346.281 6.362.04 7.904-.321 2.066-1.112 3.482-2.747 3.482.044-1.704-.092-3.591.065-5.674.156-2.066-.13-2.117-1.921-3.078-.891-.479-1.409-.977-1.963-1.754-.685-.96-.17-1.297-1.525-1.253 0 0-3.151-.103-3.229 4.538-.899-2.67-.173-5.812.9-6.794z",
  transform: "matrix(-1 0 0 1 32.978 10.145) translate(2.756 .222)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8BD9C",
  d: "M11.976 8.915s.357-1.332 1.498-.782c0 0 .516.234.144 1.149 0 0-.542 1.316-1.643.834l.001-1.201",
  transform: "matrix(-1 0 0 1 32.978 10.145) translate(2.756 .222)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M.015 29.917c-.18-6.074 1.366-8.624 2.086-9.475 1.389-2.114 3.27-2.886 3.27-2.886h0l3.732-1.334c.324 1.369 2.93 1.621 3.3 1.65l.044.003c3.637 0 3.374-1.435 3.374-1.435l4.408 1.255s1.16.309 2.248 1.335l.018.018c.232.172 2.33 1.82 2.926 5.427 0 0 .5 3.052.453 5.442z",
  transform: "matrix(-1 0 0 1 32.978 10.145)"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#D5D4D4",
  mask: "url(#p7wjnbblvb)"
})))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export default ForwardRef;